import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import Card from '@/elements/Card';
import Stack from '@/components/Stack';
import { Small, Subheading } from '@/components/Typography';
import Icon from '@/elements/Icon';
import styled from '@/styles';
import { DependabilityScore, WorkerStats } from '@/services/workersV2API';

type Props = {
  score: DependabilityScore | null;
  stats: WorkerStats | null;
};

const DependabilityWrapper = styled(Card, {
  borderTop: '3px solid $dangerDefault',
  padding: '16px 20px',
  cursor: 'default',
});

const TierBadge = styled('span', {
  fontSize: '13px',
  fontWeight: 600,
  padding: '2px 10px',
  borderRadius: '12px',

  variants: {
    tier: {
      high: {
        color: '#45A735',
      },
      medium: {
        color: '#EB9616',
      },
      low: {
        color: '#CF040C',
      },
      not_rated: {
        color: '#6C757D',
      },
    },
  },
});

const getTierVariant = (
  tier: string | null,
): 'high' | 'medium' | 'low' | 'not_rated' => {
  if (tier === 'high' || tier === 'medium' || tier === 'low') return tier;
  return 'not_rated';
};

const DependabilityCard = ({ score, stats }: Props) => {
  if (!score || !stats) return null;

  return (
    <Stack vertical gap={8}>
      <DependabilityWrapper>
        <Stack
          style={{ justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Stack vertical gap={4}>
            <Subheading weight="semibold">Dependability</Subheading>
            <Small color="lighter">
              {stats.jobs_dropped} Late Drop{' | '}
              {stats.no_show} No-show
            </Small>
          </Stack>
          <Stack gap={8} style={{ alignItems: 'center' }}>
            <TierBadge tier={getTierVariant(score.tier)}>
              {score.label}
            </TierBadge>
            <Icon
              icon={faChevronRight}
              style={{ color: '#9CA3AF', fontSize: '12px' }}
            />
          </Stack>
        </Stack>
      </DependabilityWrapper>
      <div style={{ paddingLeft: '4px' }}>
        <Small color="lighter">
          Total shifts worked: {score.completed_shifts}
        </Small>
      </div>
    </Stack>
  );
};

export default DependabilityCard;
